import { IPageFilterProps, PageFiltersRenderer } from '@diana/core';
import { useFilterOptions } from '../../stores/useFilterOptions';

export const FiltersRenderer = ({ filterProps }: { filterProps: IPageFilterProps }) => {
  const { data: queryData } = useFilterOptions();

  let data = queryData?.[filterProps.filter.property.key];

  return <PageFiltersRenderer filterProps={filterProps} data={data} isLoading={false} />;
};
